
define('ldsh!templates/main-layout', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="main__layout">\n    <main>\n        <section>\n          <div class="main__section__wrapper">\n            <div class="container container--margin">\n                <div id="md__reminders"></div>\n                <div id="noticeContainer"></div>\n                <div id="content"></div>\n            </div>\n          </div>\n          <div id="footer"></div>\n        </section>\n    </main>\n</div>\n';

}
return __p
};});

